var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import { initialState } from './initialState';
import { ACTION_CUSTOM_EXPORT as actionTypes, CONSTANTS } from '../utils/constants';
import { validateInputForAttribute } from '../utils/utils';
import { calculateCombinationsSize } from '../services/customBulkExport';

var initializeState = function initializeState(possibilitiesSet) {
  var enabledInputCustomValues = {};
  var checked = {};
  var openList = {};
  var customInput = {};
  var customExportDisabled;
  var combinationsCount;

  if (possibilitiesSet && Object.keys(possibilitiesSet).length > 0) {
    var attributes = Object.keys(possibilitiesSet);
    var open_1 = attributes.length === 1;
    attributes.forEach(function (attribute) {
      enabledInputCustomValues[attribute] = false;
      checked[attribute] = [];
      openList[attribute] = open_1;
      customInput[attribute] = {
        value: undefined,
        style: undefined,
        helpText: null
      };
    });
    combinationsCount = calculateCombinationsSize(possibilitiesSet, {});
    customExportDisabled = combinationsCount > CONSTANTS.MAXIMUM_COMBINATIONS_COUNT;
  }

  return {
    emailSentStatus: null,
    enabledInputCustomValues: enabledInputCustomValues,
    openList: openList,
    checked: checked,
    customInput: customInput,
    customExportDisabled: customExportDisabled,
    combinationsCount: combinationsCount
  };
};

export default function (state, action) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  if (state === void 0) {
    state = initialState.customBulkExport;
  }

  switch (action.type) {
    case actionTypes.INITIALIZE_STATE:
      {
        var possibilitiesSet = state.possibilitiesSet,
            originalPossibilitiesSet = state.originalPossibilitiesSet;
        var initializedState = initializeState(possibilitiesSet);
        var combinationsCount = calculateCombinationsSize(possibilitiesSet, {});
        var customExportDisabled = combinationsCount > CONSTANTS.MAXIMUM_COMBINATIONS_COUNT;
        return __assign(__assign(__assign({}, state), initializedState), {
          customExportDisabled: customExportDisabled,
          combinationsCount: combinationsCount,
          possibilitiesSet: originalPossibilitiesSet
        });
      }

    case actionTypes.TOGGLE_EXPORT_TYPE_MODAL:
      {
        return __assign(__assign({}, state), {
          emailSentStatus: null,
          emailIds: ''
        });
      }

    case actionTypes.ON_CLICK_ATTRIBUTE:
      {
        var openList = state.openList;
        var attribute = action.payload;
        return __assign(__assign({}, state), {
          openList: __assign(__assign({}, openList), (_a = {}, _a[attribute] = !openList[attribute], _a))
        });
      }

    case actionTypes.ON_CHECKBOX_TOGGLE:
      {
        var _o = action.payload,
            value = _o.value,
            attribute = _o.attribute;
        var checked = state.checked,
            possibilitiesSet = state.possibilitiesSet;
        var attributeCheckedList = checked[attribute];
        var currentIndex = attributeCheckedList.indexOf(value);

        var newChecked = __spread(attributeCheckedList);

        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }

        var updatedChecked = __assign(__assign({}, checked), (_b = {}, _b[attribute] = newChecked, _b));

        var combinationsCount = calculateCombinationsSize(possibilitiesSet, updatedChecked);
        var customExportDisabled = combinationsCount > CONSTANTS.MAXIMUM_COMBINATIONS_COUNT;
        return __assign(__assign({}, state), {
          checked: updatedChecked,
          combinationsCount: combinationsCount,
          customExportDisabled: customExportDisabled
        });
      }

    case actionTypes.SHOW_ADD_VALUE_LINK:
      {
        var attribute = action.payload;
        var enabledInputCustomValues = state.enabledInputCustomValues;
        return __assign(__assign({}, state), {
          enabledInputCustomValues: __assign(__assign({}, enabledInputCustomValues), (_c = {}, _c[attribute] = true, _c))
        });
      }

    case actionTypes.ON_SUBMIT_CUSTOM_INPUT:
      {
        var attribute = action.payload;
        var possibilitiesSet = state.possibilitiesSet,
            enabledInputCustomValues = state.enabledInputCustomValues,
            customInput = state.customInput;
        var attributeInfo = possibilitiesSet[attribute];
        var input = customInput[attribute];

        if (input.value && input.style === 'success') {
          var finalAttributeInfo = __assign(__assign({}, attributeInfo), {
            possibleValues: __spread(attributeInfo.possibleValues, [input.value])
          }); // add element to end of array immutably


          return __assign(__assign({}, state), {
            enabledInputCustomValues: __assign(__assign({}, enabledInputCustomValues), (_d = {}, _d[attribute] = false, _d)),
            possibilitiesSet: __assign(__assign({}, possibilitiesSet), (_e = {}, _e[attribute] = finalAttributeInfo, _e)),
            customInput: __assign(__assign({}, customInput), (_f = {}, _f[attribute] = __assign(__assign({}, customInput[attribute]), {
              value: undefined
            }), _f))
          });
        }

        return state;
      }

    case actionTypes.ON_BLUR_CUSTOM_INPUT:
      {
        var attribute = action.payload;
        var possibilitiesSet = state.possibilitiesSet,
            enabledInputCustomValues = state.enabledInputCustomValues,
            customInput = state.customInput;
        var input = customInput[attribute];

        if (!input.value || input.value === '') {
          return __assign(__assign({}, state), {
            enabledInputCustomValues: __assign(__assign({}, enabledInputCustomValues), (_g = {}, _g[attribute] = false, _g))
          });
        }

        if (input.style === 'success') {
          var attributeData = possibilitiesSet[attribute];

          var finalData = __assign(__assign({}, attributeData), {
            possibleValues: __spread(attributeData.possibleValues, [input.value])
          });

          return __assign(__assign({}, state), {
            possibilitiesSet: __assign(__assign({}, possibilitiesSet), (_h = {}, _h[attribute] = finalData, _h)),
            enabledInputCustomValues: __assign(__assign({}, enabledInputCustomValues), (_j = {}, _j[attribute] = false, _j)),
            customInput: __assign(__assign({}, customInput), (_k = {}, _k[attribute] = __assign(__assign({}, customInput[attribute]), {
              value: undefined
            }), _k))
          });
        }

        return state;
      }

    case actionTypes.ON_CUSTOM_INPUT_CHANGE:
      {
        var _p = action.payload,
            value = _p.value,
            attribute = _p.attribute;
        var possibilitiesSet = state.possibilitiesSet,
            customInput = state.customInput;
        var attributeInfo = possibilitiesSet[attribute]; // TODO: Fix this
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        // eslint-disable-next-line no-restricted-globals

        var inputValue = event.target.value ? parseFloat(event.target.value) : undefined;

        if (value) {
          var style = 'error';
          var helpText = null;
          var isValid = validateInputForAttribute(inputValue, attributeInfo);
          var alreadyExists = attributeInfo.possibleValues.indexOf(value) > -1;

          if (alreadyExists) {
            style = 'error';
            helpText = 'Value already exists';
          } else if (!isValid) {
            style = 'error';
            helpText = 'Invalid input';
          } else {
            style = 'success';
            helpText = null;
          }

          return __assign(__assign({}, state), {
            customInput: __assign(__assign({}, customInput), (_l = {}, _l[attribute] = {
              style: style,
              helpText: helpText,
              value: value
            }, _l))
          });
        }

        return __assign(__assign({}, state), {
          customInput: __assign(__assign({}, customInput), (_m = {}, _m[attribute] = __assign(__assign({}, customInput[attribute]), {
            value: value
          }), _m))
        });
      }

    case actionTypes.LOAD_POSSIBILITIES_SET_FROM_RULE_SET:
      {
        var _q = action.payload,
            sku = _q.sku,
            ruleSetInfo_1 = _q.ruleSetInfo;
        var possibilitiesSetMap_1 = {};
        var initializedState = void 0;

        if (ruleSetInfo_1 && ruleSetInfo_1.allAttributeValues) {
          Object.keys(ruleSetInfo_1.allAttributeValues).map(function (attributeKey) {
            var attribute = ruleSetInfo_1.allAttributeValues[attributeKey];

            if (attribute.isRange) {
              possibilitiesSetMap_1[attributeKey] = __assign(__assign({}, attribute), {
                possibleValues: attribute.defaults.map(String)
              });
            } else {
              possibilitiesSetMap_1[attributeKey] = __assign(__assign({}, attribute), {
                possibleValues: attribute.values.map(String)
              });
            }

            return undefined;
          });
          initializedState = initializeState(possibilitiesSetMap_1);
        }

        return __assign(__assign(__assign({}, state), initializedState), {
          sku: sku,
          possibilitiesSet: possibilitiesSetMap_1,
          originalPossibilitiesSet: possibilitiesSetMap_1
        });
      }

    case actionTypes.TOGGLE_EMAIL_SENT_STATUS:
      {
        return __assign(__assign({}, state), {
          showEmailModal: false,
          emailSentStatus: action.payload,
          emailIds: ''
        });
      }

    default:
      return state;
  }
}